import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { camouflageKeys, CamouflageOwnerType } from "../types/camouflageTypes";

const getData = async (type:CamouflageOwnerType, slug:string|null) => {
  ///api/v1/users/me/camouflages/
  // 
  const endpoint = type === 'profile' ? '/users/me/camouflages/' : `/teams/${slug}/camouflages/`
  const response = await axios.get(endpoint)
  return response.data
};

export default function useProfileCamouflages(type:CamouflageOwnerType, slug: string|null = null) {

  const qKeys = camouflageKeys[type]

    const { data, isLoading, error } = useQuery({
    queryKey: qKeys,
    queryFn: () => getData(type, slug),
  });

  return { data, isLoading, error }
}